import React from 'react';
import {Row, Col, Tabs, Button} from 'antd';
import {marginBottom, marginLeft, marginRight, marginTop, paddingBottom, paddingTop} from "../../common/script";


export default class ECommencePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabList: [{
                title: 'Amazon FBA',
                detailHList: ['· Customized delivery service', '· Multiple delivery scheme', '· Section 321 parcel clearance', '· Overseas warehouse generation delivery']
            }, {
                title: 'Business Courier',
                detailVList: ['· You can choose the right type of service in accordance with the degree of urgency to ensure the on-time delivery.']
            }, {
                title: 'Consolidation & Bulk Services',
                detailVList: [
                    '· To meet the demands of both Online shoppers and E-commerce merchants, VeryExpress also provides the consolidation and bulk products for customers delivering the parcel pre-planned.',
                    '· Free parcel acceptance, inspection, photography and warehousing have also been included in the service.'
                ]
            }, {
                title: 'Big Parcels',
                detailVList: [
                    '· Similar services like FedEx or UPS, VeryExpress wins faster deliver & lower cost as well as the smoother clearance, in order to send big parcels out of China.',
                ]
            }],
            detailList: [{
                title: 'Capacity direct procurement',
                info: [
                    '·Large e-commerce and logistics platforms directly purchase multi-waypoint capacity throughout the year',
                    '·Annual prices, off-peak season plans, PRP shipping space',
                    '·Support global import to China cabin service',
                ],
                img: 'https://qiniu.mrcargo.com/zs_commence_service_1.png',
            }, {
                title: 'Domestic warehousing services',
                info: [
                    '·Shanghai, Shenzhen, Guangzhou, Hong Kong four export collection',
                    '·Support multi-place warehouse standardization in and out of the warehouse, shelves and other online visualization operations',
                    '·Bonded warehouse customs clearance, filing, re-export services',
                ],
                img: 'https://qiniu.mrcargo.com/zs_commence_service_2.png',
            }, {
                title: 'Overseas warehouse + delivery',
                info: [
                    '·Global multi-site overseas warehousing customs clearance service',
                    '·Shipping service label printing, payment is done online',
                    '·Autonomous information system to integrate overseas tracking information',
                ],
                img: 'https://qiniu.mrcargo.com/zs_commence_service_3.png',
            }],
            bottomList: [{
                icon: 'images/ic_customer_normal.png',
                select: 'images/ic_customer_selected.png',
                title: 'Online Rate Inquiry',
                img: 'https://qiniu.mrcargo.com/zs_commence_other_3.png'
            }, {
                icon: 'images/ic_cargo_normal.png',
                select: 'images/ic_cargo_selected.png',
                title: 'Track Visibility',
                img: 'https://qiniu.mrcargo.com/zs_commence_other_1.png'
            }, {
                icon: 'images/ic_api_normal.png',
                select: 'images/ic_api_selected.png',
                title: 'Flexible API',
                img: 'https://qiniu.mrcargo.com/zs_commence_other_2.png'
            }],
            bottomIndex: 0
        }
    }


    render() {
        return (<div>
                <div style={{position: 'relative'}} className={'flex-row width100p'}>
                    <img src={'https://qiniu.mrcargo.com/zs_commence_banner.png'} alt={'zs_commence_banner'}
                         className={'width100p'}/>
                    <div className={'width100p first-context font-size64 text-center'} style={marginTop(10)}>
                        <span className={'colorfff'}>E-Commence Solution</span>
                    </div>
                </div>
                <div style={{position: 'relative'}} className={'flex-row width100p'}>
                    <img src={'https://qiniu.mrcargo.com/zs_commence_bg_grid.png'} alt={'zs_commence_bg_grid'}
                         className={'width100p'}/>
                    <Row justify={'center'} className={'width100p first-context'}>
                        <Col span={12} style={Object.assign(marginTop(8))}>
                            <div >
                                <span className={'quotes-view'}>"</span>
                                <span className={'font-size18 color0D182B font-bold'} style={marginTop(2)}>E-commerce will change the
                                    way global trade is conducted, and smarter and more flexible supply chain solutions are
                                    the trend of the times.
                                </span>
                                <span className={'quotes-view'}>"</span>
                            </div>
                        </Col>
                    </Row>
                </div>

                <Col className={'font-size48 font-weight400 color1E170B'} offset={4} style={marginTop(8)} >E-commerce Service Solution</Col>
                <Tabs defaultActiveKey="0" centered size={'large'} style={marginTop(4)} className={'e_commence_tab'}>
                    {
                        this.state.tabList.map((item, index) => {
                            return <Tabs.TabPane tab={item.title} key={index}>
                                <div className={'bg-f5f7fa'}>
                                    <Row style={Object.assign(paddingTop(5), paddingBottom(5))}>
                                        {
                                            (item.detailHList || []).map((subItem, subIndex) => {
                                                return <Col offset={subIndex % 2 === 0 ? 8 : 1} span={4} key={`detailHList${subIndex}`}
                                                            style={subIndex > 1 ? marginTop(2) : ''}>{subItem}</Col>
                                            })
                                        }
                                        {
                                            (item.detailVList || []).map((subItem, subIndex) => {
                                                return <Col offset={8} span={8} key={`detailVList${subIndex}`}
                                                            style={subIndex !== 0 ? marginTop(2) : ''}>{subItem}</Col>
                                            })
                                        }
                                    </Row>
                                </div>
                            </Tabs.TabPane>
                        })
                    }
                </Tabs>
                <Col className={'font-size48 font-weight400 color1E170B'} offset={4} style={marginTop(8)}>E-commerce
                    Service Programme</Col>
                <Row gutter={[24, 24]} style={marginTop(8)}>
                    {
                        this.state.detailList.map((item, index) => {
                            return <Col key={`detail${index}`} offset={index === 0 ? 4 : 0} span={5}>
                                <div className={'bg-fafafa'} style={{height: '450px'}}>
                                    <img src={item.img} alt={item.img} className={'width100p'}/>
                                    <div style={Object.assign(marginLeft(2), marginRight(2))}>
                                        <div className={'font-size18 colorDefault font-bold font-sans font-italic'}
                                             style={marginTop(4)}>{item.title}</div>
                                        {
                                            item.info.map((subItem, subIndex) => {
                                                return <div key={`sub${subIndex}`} style={marginTop(3)}>{subItem}</div>
                                            })
                                        }
                                    </div>
                                </div>
                            </Col>;
                        })
                    }
                </Row>
                <div style={Object.assign({position: 'relative'}, marginTop(8))} className={'flex-row width100p'}>
                    <img src={' https://qiniu.mrcargo.com/zs-warehouse-bg-bottom.png'} alt={'zs-warehouse-bg-bottom'}
                         width={'100%'}/>
                    <div className={'width100p  first-context'}>
                        <div style={Object.assign(marginLeft(40), marginTop(2))}>
                            <div className={'font-size40 colorfff font-weight400'} style={marginTop(6)}>
                                <div>Contact us quickly</div>
                                <div>to get the fastest and best service</div>
                            </div>
                            <Button type="primary" shape="default" size={'large'}
                                    className={'concat-btn'}
                                    style={marginTop(5)} onClick={() => {
                                this.props.navigationRoute('/concatUs')
                            }
                            }>Need to contact </Button>
                        </div>
                    </div>
                </div>
                <Row gutter={[16, 16]} style={Object.assign(marginTop(8), marginBottom(8))}>
                    <Col offset={4} span={5}>
                        <div className={'flex-col justify-between'} style={{height: '100%'}}>
                            {
                                this.state.bottomList.map((item, index) => {
                                    return <div key={`bottomList${index}`}
                                                onClick={()=>{
                                                    this.setState({
                                                        bottomIndex:index
                                                    })
                                                }}
                                                className={`flex-row e-commence-bottom-block width100p ${this.state.bottomIndex === index ? 'block-selected' : 'block-normal'}`}>
                                        <img src={this.state.bottomIndex === index?item.select:item.icon} alt={item.icon} style={marginLeft(8)}/>
                                        <div style={marginLeft(2)}>{item.title}</div>
                                    </div>
                                })
                            }
                        </div>
                    </Col>
                    <Col span={12}>
                        <img src={this.state.bottomList[this.state.bottomIndex].img} alt={this.state.bottomList[this.state.bottomIndex].img}/>
                    </Col>
                </Row>
            </div>
        );
    }


}


